export const startSocialAuth = () => ({
  type: 'SOCIAL_AUTH_START'
});

export const successSocialAuth = user => ({
  type: 'SOCIAL_AUTH_SUCCESS',
  user
});

export const failedSocialAuth = () => ({
  type: 'SOCIAL_AUTH_FAILED'
});

export const successAuth = (user, response) => ({
  type: 'AUTH_SUCCESS',
  user: user[0],
  response
});

export const failedAuth = () => ({
  type: 'AUTH_FAILED'
});

export const logoutUser = () => ({
  type: 'AUTH_LOGOUT'
});



// WEBPACK FOOTER //
// ./src/actions/user.js